export enum DownloadFormat {
  PNG = `PNG`,
  PDF = `PDF`,
  CSV = `CSV`,
}

const DOWNLOAD_PREFIX = `download-`;

export function isScreenshotDownloadFormat(format: DownloadFormat): boolean {
  return [DownloadFormat.PNG, DownloadFormat.PDF].includes(format);
}

function isDownloadFormat(format: string): format is DownloadFormat {
  return (Object.values(DownloadFormat) as string[]).includes(format);
}

export function getDownloadFormatFromAction(action: string): DownloadFormat {
  if (!action.startsWith(DOWNLOAD_PREFIX)) {
    return null;
  }
  const format = action.split(`-`)[1];
  return isDownloadFormat(format) ? format : null;
}

type GetDownloadOptionsParams = {
  downloadFormats?: DownloadFormat[];
  hasCanExportCsvFeatureGate?: boolean;
  hasDownloadCsvDataPermission?: boolean;
};

export function getDownloadOptions({
  downloadFormats = [DownloadFormat.PNG, DownloadFormat.PDF, DownloadFormat.CSV],
  hasCanExportCsvFeatureGate,
  hasDownloadCsvDataPermission,
}: GetDownloadOptionsParams = {}) {
  const hasPermissionMap = {
    [DownloadFormat.PNG]: true,
    [DownloadFormat.PDF]: true,
    [DownloadFormat.CSV]: hasDownloadCsvDataPermission,
  };

  const hasFeatureAccessMap = {
    [DownloadFormat.PNG]: true,
    [DownloadFormat.PDF]: true,
    [DownloadFormat.CSV]: hasCanExportCsvFeatureGate,
  };

  return downloadFormats
    .filter((format) => hasPermissionMap[format])
    .map((format) => {
      if (hasFeatureAccessMap[format]) {
        return {
          icon: `export-${format.toLowerCase()}`,
          label: `Download ${format}`,
          value: `${DOWNLOAD_PREFIX}${format}`,
          isDisabled: !hasPermissionMap[format],
          ...(!hasPermissionMap[format]
            ? {tooltip: {text: `Contact your project administrator to enable`, placement: `left`}}
            : {}),
        };
      } else {
        return {
          value: `upsell-download-${format}`,
          icon: `share`,
          label: `Upgrade to Download ${format}`,
          tooltip: {
            text: `Upgrade your plan to export reports as ${format}`,
            placement: `left`,
          },
          href: `/pricing/`,
          target: `_blank`,
          wrapLabel: true,
        };
      }
    });
}
